import React from 'react'
import { Link } from 'react-router-dom'
import guideImg1_1 from '../../assets/images/sub/guide_img1_1.png'
import guideImg1_2 from '../../assets/images/sub/guide_img1_2.png'
import guideImg1_3 from '../../assets/images/sub/guide_img1_3.png'
import guideImg1_4 from '../../assets/images/sub/guide_img1_4.png'
import guideImg1_5 from '../../assets/images/sub/guide_img1_5.png'
import guideImg1_6 from '../../assets/images/sub/guide_img1_6.png'

import guideImgM1_1 from '../../assets/images/sub/guide_img1_1_m.png'
import guideImgM1_2 from '../../assets/images/sub/guide_img1_2_m.png'
import guideImgM1_3 from '../../assets/images/sub/guide_img1_3_m.png'
import guideImgM1_4 from '../../assets/images/sub/guide_img1_4_m.png'
import guideImgM1_5 from '../../assets/images/sub/guide_img1_5_m.png'
import guideImgM1_6 from '../../assets/images/sub/guide_img1_6_m.png'

const GuideSubmit = (props) => {
  const mobileSelectBoxEvent = (e) => {
    e.preventDefault()
    e.target.classList.toggle('on')
  }

  return (
    <React.Fragment>
      <div className="guide-box gray mt0">
        <dl className="dlist3">
          <dt>전자문서지갑 안내</dt>
          <dd>
            종이증명서를 PC 또는 전자문서지갑 앱을 통해 전자증명서로 발급받아 열람하고 원하는 기관에 제출할 수 있는 유통수단 서비스입니다.
          </dd>
        </dl>
      </div>
      <ul className="nav-tab w200 mt40">
        <li className="on">
          <button onClick={props.submitPage}>증명서 발급 · 제출 안내</button>
        </li>
        <li>
          <button onClick={props.confirmPage}>증명서 진위확인 안내</button>
        </li>
      </ul>

      {/* <!-- //mobile --> */}
      <div className="nav-wrap">
        <label className="current-menu2" onClick={mobileSelectBoxEvent}>
          증명서 발급 · 제출 안내
        </label>
        <ul className="nav-menu">
          <li style={{ textAlign: 'center', marginBottom: '10px' }} className="on">
            <label onClick={props.submitPage}>증명서 발급 · 제출 안내</label>
          </li>
          <li style={{ textAlign: 'center', marginTop: '10px' }}>
            <label onClick={props.confirmPage}>증명서 진위확인 안내</label>
          </li>
        </ul>
      </div>

      {/* <!-- //mobile --> */}
      <ul className="step-guide">
        <li>
          <div className="box">
            <dl className="type2">
              <dt>
                <span>STEP 1.</span> 법인/개인회원 로그인
              </dt>
              <dd>전자문서지갑 회원이 아닌 경우 회원가입 후 이용바랍니다.</dd>
              <dd className="btn">
                <Link to="/regis/join" className="btn-secondary md">
                  회원가입 하기
                </Link>
              </dd>
            </dl>
            <div className="thumb">
              <img src={guideImg1_1} alt="법인/개인회원 로그인" className="pc-only" />
              <img src={guideImgM1_1} alt="법인/개인회원 로그인" className="mobile-only" />
            </div>
          </div>
          <div className="box">
            <dl>
              <dt>
                <span>STEP 2.</span> 원하는 증명서 선택
              </dt>
              <dd>신청가능한 증명서 목록에서 원하는 증명서를 확인 후 [신청]버튼을 클릭합니다.</dd>
            </dl>
            <div className="thumb">
              <img src={guideImg1_2} alt="원하는 증명서 선택" className="pc-only" />
              <img src={guideImgM1_2} alt="원하는 증명서 선택" className="mobile-only" />
            </div>
          </div>
        </li>
        <li>
          <div className="box">
            <dl>
              <dt>
                <span>STEP 3.</span> 증명서 발급 신청
              </dt>
              <dd>신청정보를 입력 후 발급 신청을 완료합니다.</dd>
            </dl>
            <div className="thumb">
              <img src={guideImg1_3} alt="증명서 발급 신청" className="pc-only" />
              <img src={guideImgM1_3} alt="증명서 발급 신청" className="mobile-only" />
            </div>
          </div>
          <div className="box">
            <dl>
              <dt>
                <span>STEP 4.</span> 신청내역 확인
              </dt>
              <dd>증명서 신청현황 확인을 확인합니다.</dd>
            </dl>
            <div className="thumb">
              <img src={guideImg1_4} alt="신청내역 확인" className="pc-only" />
              <img src={guideImgM1_4} alt="신청내역 확인" className="mobile-only" />
            </div>
          </div>
        </li>
        <li>
          <div className="box">
            <dl>
              <dt>
                <span>STEP 5.</span> 발급문서 확인
              </dt>
              <dd>발급 완료된 증명서를 확인 후, 제출을 원하는 문서를 선택하여 [제출]버튼을 클릭합니다.</dd>
            </dl>
            <div className="thumb">
              <img src={guideImg1_5} alt="발급문서 확인" className="pc-only" />
              <img src={guideImgM1_5} alt="발급문서 확인" className="mobile-only" />
            </div>
          </div>
          <div className="box">
            <dl>
              <dt>
                <span>STEP 6.</span> 증명서 제출
              </dt>
              <dd>선택한 증명서를 기관(법인), 지갑주소, 1회 열람 서비스를 이용해 원하는 기관에 제출합니다.</dd>
            </dl>
            <div className="thumb">
              <img src={guideImg1_6} alt="증명서 제출" className="pc-only" />
              <img src={guideImgM1_6} alt="증명서 제출" className="mobile-only" />
            </div>
          </div>
        </li>
      </ul>
    </React.Fragment>
  )
}

export default GuideSubmit
